import { useCallback, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import { getPageTitle } from "../../../../store/selectors";

const SearchBar = () => {
  const [barValue, setBarValue] = useState("");
  const pageTitle = useSelector(getPageTitle);

  const handleInputChange = useCallback(
    ({ target: { value = null } = {} }) => setBarValue(value),
    [setBarValue]
  );

  return (
    <InputGroup>
      <Form.Control
        className="pdl_component_searchbar"
        size="lg"
        type="text"
        placeholder={pageTitle || "Plataforma LEX"}
        value={barValue}
        onChange={handleInputChange}
      />
      <Button variant="primary" className="px-3">
        <FaSearch size="20" />
      </Button>
    </InputGroup>
  );
};

export default SearchBar;
